<template>
  <Breadcrumb :items="breadcrumbItems" v-if="!props.acaoId" />

  <div class="header-menu-noticias" v-if="!props.acaoId">
    <h2 class="titulo-pagina">Notícias da Extensão</h2>
    <div class="header-actions">
      <FiltrosComponent :isCoordenador="isCoordenador" :nomeTela="'noticia'" @pesquisar="onPesquisar" />
    </div>
  </div>

  <FiltrosComponent v-else :isCoordenador="isCoordenador" :nomeTela="'noticia'" @pesquisar="onPesquisar" />

  <Carregamento v-if="isLoading" />

  <div id="noticias" v-else>
    <div class="lista" v-for="noticia in noticias" :key="noticia.id">
      <NoticiasCard :noticia="noticia" :isCoordenador="isCoordenador" />
    </div>

    <!-- Mensagem quando não há notícias -->
    <AvisoListagem v-if="noticias.length === 0 && !isLoading">
      Nenhuma notícia encontrada.
    </AvisoListagem>
  </div>

  <PaginacaoComponent v-if="!isLoading" :total-paginas="totalPages" @mudar-pagina="carregarPagina" />
</template>

<script>
export default { name: "MenuNoticiasView" };
</script>
<script setup>
import { watch, computed } from "vue";
import PaginacaoComponent from "@/components/common/paginacaoComponent.vue";
import { useRouter, useRoute } from "vue-router";
import FiltrosComponent from "@/components/common/FiltrosComponent.vue";
import Carregamento from "@/components/common/Carregamento.vue";
import Breadcrumb from "@/components/common/Breadcrumb.vue";
import NoticiasCard from "@/components/noticias/NoticiasCard.vue";
import AvisoListagem from "@/components/common/AvisoListagem.vue";
import { useNoticias } from "@/composables/useNoticias";
import { useAuthStore } from "@/stores/auth";

const router = useRouter();
const route = useRoute();
const authStore = useAuthStore();

const breadcrumbItems = computed(() => {
  return [
    { label: "Início", to: "/" },
    { label: "Notícias", to: "/noticias" },
  ];
});

const {
  noticias,
  isLoading,
  fetchFiltrosNoticia,
  totalPages,
} = useNoticias();

const props = defineProps({
  isAtiva: Boolean,
  isCoordenador: {
    type: Boolean,
    default: false,
  },
  acaoId: String,
});

watch(
  [() => route.query, () => props.acaoId, () => authStore.isAutenticado],
  async ([newQuery]) => {
    const termo = newQuery?.q || "";
    const dataInicial = newQuery?.dataInicial || "";
    const dataFinal = newQuery?.dataFinal || "";
    const unidadeIdParam = newQuery?.unidadeId || null;
    const pagina = Number(newQuery?.page) || 0;

    let targetUnidadeId = null;
    let targetAbrangencia = null;

    if (props?.acaoId) {
      targetUnidadeId = null;
      targetAbrangencia = null;
    } else if (unidadeIdParam === "TODAS") {
      targetUnidadeId = null;
      targetAbrangencia = null;
    } else if (unidadeIdParam) {
      targetUnidadeId = unidadeIdParam;
      targetAbrangencia = null;
    } else {
      targetUnidadeId = null;
      targetAbrangencia = "PREX";
    }

    fetchFiltrosNoticia({
      page: pagina,
      size: 5,
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      unidadeId: targetUnidadeId,
      abrangencia: targetAbrangencia,
      titulo: termo,
      acaoId: props?.acaoId,
    });
  },
  { immediate: true }
);

function carregarPagina(pagina) {
  const query = { ...route.query };
  if (pagina > 0) {
    query.page = pagina;
  } else {
    delete query.page;
  }

  router.push({ query });
}

function onPesquisar(termo) {
  const query = { ...route.query };
  if (termo && termo.trim()) {
    query.q = termo.trim();
  } else {
    delete query.q;
  }
  delete query.page;

  router.push({ query });
}
</script>

<style scoped>
.header-menu-noticias {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 24px;
  padding-bottom: 15px;
  border-bottom: 1px solid lightgray;
  width: 100%;
}

.titulo-pagina {
  padding-bottom: 0;
  margin: 0;
}

.header-actions {
  display: flex;
  align-items: end;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 16px;
}

.header-actions :deep(.barra-acoes) {
  border-bottom: none !important;
  padding: 0 !important;
  margin: 0 !important;
  width: auto !important;
  display: flex !important;
  align-items: center !important;
  justify-content: flex-end !important;
  gap: 16px !important;
}

.lista {
  width: 100%;
  max-height: 216px;
  margin-bottom: 1rem;
}

@media (max-width: 600px) {
  .lista {
    max-height: none;
  }
}
</style>
